import { ImageComposer } from "../image/ImageComposer";
import { VideoComposer } from "../video/VideoComposer";
import type { ComposerProps } from "./use-composer";

/**
 * The studio's composer: the image or the video one, by the page's medium, as live has one form
 * per studio (design-system.md 3.3). Both share `useComposer`, the one draft and price.
 */
export function Composer(props: ComposerProps) {
  return props.medium === "video" ? <VideoComposer {...props} /> : <ImageComposer {...props} />;
}
